<template>
  <div class="noviceGuide">

    <div class="list-item" v-for="(item, i) in list" :key="item.key" @click="goPage(item.key)">
      <span class="text">{{ item.key }}、{{ item.title }}</span>
      <span class="icon"></span>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        list: [
          {key: 1, title: '如何在云柑5G云店开店?'},
          {key: 2, title: '如何完成店铺实名认证?'},
          {key: 3, title: '如何设置商品分类?'},
          {key: 4, title: '如何发布店铺商品?'},
          {key: 5, title: '如何编辑商品规格和详情?'},
          {key: 6, title: '如何管理店铺商品?'},
          {key: 7, title: '如何设置导航栏?'},
          {key: 8, title: '如何设置商品运费?'},
          {key: 9, title: '如何设置分享分销奖励?'},
          {key: 10, title: '如何管理店铺订单?'},
          {key: 11, title: '如何选择云店模板?'},
          {key: 12, title: '如何进行资金提现?'},
          {key: 13, title: '如何设置店铺主播?'},
          {key: 14, title: '如何设置店铺广告?'},
          {key: 15, title: '如何分销店铺商品?'},
          {key: 16, title: '如何设置推广员?'},
          {key: 17, title: '店铺会员如何设置?'},
          {key: 18, title: '活动如何设置?'},
          {key: 19, title: '线下服务的设置'},
        ],
      }
    },
    created() {
      
    },
    methods: {
      goPage(i){
        this.$router.push({name: 'question', query: {question: i}})
      }
    }
  }
</script>

<style lang="less" scoped>
.noviceGuide{
  width: 100%;
  position: absolute;z-index: 0;
  top: 0;right: 0;right: 0;bottom: 0;
  background-color: #F4F4F4;
  overflow-y: auto;
  padding-bottom: 40px;
  .list-item{
    display: flex;align-items: center;
    background-color: #fff;border-radius: 10px;color: #333;
    width: 351px;height: 46px;font-size: 14px;margin: 10px auto 0;
    .text{
      flex: 1;padding-left: 14px;
    }
    .icon{
      display: inline-flex;width: 45px;height: 100%;
      background: url("https://fileqn.anttalk.vip/5gShopApp/nextPage.png") no-repeat 50% 50%;
      background-size: 15px;
    }
  }
}
</style>